import React, { useState } from 'react';
import { Container, Typography, Tabs, Tab, Box } from '@mui/material';
import QuestionList from './QuestionList';
import QuestionForm from './QuestionForm';
import BulkUpload from './BulkUpload';

export default function MbeAdminMainPage() {
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [tab, setTab] = useState('list');

  const handleTabChange = (_, newValue) => {
    setTab(newValue);
    if (newValue === 'list' || newValue === 'bulk') {
      setEditingQuestion(null);
    }
  };

  const handleFormTabClick = () => {
    if (editingQuestion) {
      setEditingQuestion(null);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h3" fontWeight={700} gutterBottom>
        MBE 문제 입력/관리 (Admin)
      </Typography>
      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab label="문제 목록" value="list" />
        <Tab 
          label={editingQuestion ? "문제 수정" : "문제 추가"} 
          value="form" 
          onClick={handleFormTabClick}
        />
        <Tab label="대량 업로드" value="bulk" />
      </Tabs>
      <Box hidden={tab !== 'list'}><QuestionList setEditingQuestion={setEditingQuestion} setTab={setTab} /></Box>
      <Box hidden={tab !== 'form'}><QuestionForm editingQuestion={editingQuestion} /></Box>
      <Box hidden={tab !== 'bulk'}><BulkUpload /></Box>
    </Container>
  );
}
